import { render, staticRenderFns } from "./DiscountsPage.vue?vue&type=template&id=2a9a56f8&scoped=true&"
import script from "./DiscountsPage.vue?vue&type=script&lang=js&"
export * from "./DiscountsPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsPage.vue?vue&type=style&index=0&id=2a9a56f8&scoped=true&lang=scss&"
import style1 from "./DiscountsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a56f8",
  null
  
)

export default component.exports